import { RouteConfig } from 'vue-router'
import IBaseModule from '../common/contracts/base-module.interface'
import levelOneRoutes from './routes/level-one.router'
import adminUser from './store/admin-user.store'
import product from './store/product.store'
export default class LevelOneModule implements IBaseModule {
  store (): object {
    return {
      adminUser,
      product
    }
  }

  routes (): RouteConfig[] {
    return [
      ...levelOneRoutes
    ]
  }
}
